/**
 * Canonical profile sharing utilities (T&P-25).
 *
 * Every profile link shared from the website must use the canonical production
 * domain (https://www.tickandpass.com/profile/<id>), regardless of whether the
 * application is being accessed from production, test.tickandpass.com, staging,
 * or localhost.
 */

export const CANONICAL_PROFILE_BASE_URL = "https://www.tickandpass.com/profile/";

/**
 * Generates the canonical profile share URL for a given profile ID or share token.
 *
 * @param {string|null|undefined} profileIdOrToken - The shareToken or profile ID.
 * @returns {string|null} The canonical URL, or null if the input is empty or invalid.
 */
export function getCanonicalProfileShareUrl(profileIdOrToken) {
  if (profileIdOrToken == null) return null;
  const trimmed = String(profileIdOrToken).trim().replace(/^\/+|\/+$/g, "");
  if (!trimmed) return null;
  return `${CANONICAL_PROFILE_BASE_URL}${encodeURIComponent(trimmed)}`;
}
